import { MintBranchScene, type BranchStory } from '../../shared/MintBranchScene';

/** Domain concepts only: MINT-TRAVEL.md §5 confirms positioning, not features. */
export class MintTravelScene extends MintBranchScene {
  protected readonly story: BranchStory = {
    product: 'mint-travel',
    concepts: ['People', 'Places', 'Events', 'Time', 'Context', 'Information'],
    problem: ['A DIFFERENT DOMAIN.', 'THE SAME FOUNDATION.'],
    closing: ['CONTEXT CHANGES.', 'THE INTELLIGENCE FOUNDATION REMAINS.'],
    seed: 711,
  };
}
